/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { Iceutility } from '../../services/iceutility';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { lodgemembershipsummary } from '../stats/lodgemembshipsummary';
import { reportfilter } from './subs/reportfilter';

export class reporttemplate extends IceEntity {
  report_template_key: string = "";
  report_template_type: IceTypes.ReportType = IceTypes.ReportType.rtUndefined;
  template_report_key: string = "";
  template_report_name: string = ""
  notebook_page_key: string = ""
  notebook_page_name: string = ""
  plain_text: string = "";
  cfield_data: string = "";

  RPTFILTER: reportfilter[] = [];
  LODGE_MEMBERSHIP_SUMMARY: lodgemembershipsummary[] = [];

  constructor(cpy?: reporttemplate) {
    super();

    if (cpy != null) {
      // skip the primary key
      this.report_template_type = cpy.report_template_type;
      this.template_report_key = cpy.template_report_key;
      this.template_report_name = cpy.template_report_name;
      this.notebook_page_key = cpy.notebook_page_key;
      this.notebook_page_name = cpy.notebook_page_name;
      this.plain_text = cpy.plain_text;
      this.cfield_data = cpy.cfield_data;
      for (let ifil = 0; ifil < cpy.RPTFILTER.length; ifil++) {
        let filtr = new reportfilter(cpy.RPTFILTER[ifil]);
        this.RPTFILTER.push(filtr);
      }

      for (let ildg = 0; ildg < cpy.LODGE_MEMBERSHIP_SUMMARY.length; ildg++) {
        let ldg = new lodgemembershipsummary(cpy.LODGE_MEMBERSHIP_SUMMARY[ildg]);
        this.LODGE_MEMBERSHIP_SUMMARY.push(ldg);
      }
    }
  }

  gettablename(): string {
    return "REPORT_TEMPLATE";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "RPTFILTER") return true;
    else if (ColumnName == "LODGE_MEMBERSHIP_SUMMARY") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "RPTFILTER") return "REPORT_FILTER";
    else if (ColumnName == "LODGE_MEMBERSHIP_SUMMARY") return "LODGE_MEMBERSHIP_SUMMARY";

    return null;
  }
}
